module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-drop-down-f6ce6c01cf911cce66c2b75c023598cd.svg";